module.exports = __webpack_public_path__ + "img/vacio.7b071fbd.svg";